module.exports = __webpack_public_path__ + "img/淡印白膜白底.856adb50.jpg";